/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PublishHouseDto from './PublishHouseDto';

/**
 * The SupplierMainDto model module.
 * @module model/SupplierMainDto
 * @version v1.0.0
 */
class SupplierMainDto {
    /**
     * Constructs a new <code>SupplierMainDto</code>.
     * @alias module:model/SupplierMainDto
     */
    constructor() { 
        
        SupplierMainDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SupplierMainDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SupplierMainDto} obj Optional instance to populate.
     * @return {module:model/SupplierMainDto} The populated <code>SupplierMainDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SupplierMainDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('publishHouses')) {
                obj['publishHouses'] = ApiClient.convertToType(data['publishHouses'], [PublishHouseDto]);
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} description
 */
SupplierMainDto.prototype['description'] = undefined;

/**
 * @member {String} id
 */
SupplierMainDto.prototype['id'] = undefined;

/**
 * @member {String} name
 */
SupplierMainDto.prototype['name'] = undefined;

/**
 * @member {Array.<module:model/PublishHouseDto>} publishHouses
 */
SupplierMainDto.prototype['publishHouses'] = undefined;

/**
 * @member {Number} seq
 */
SupplierMainDto.prototype['seq'] = undefined;






export default SupplierMainDto;

